import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  returnTypeConditionFromModel,
  validateReturnTypeCondition,
  type ReturnTypeState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const RETURN_TYPE = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ReturnTypeState>>,
): ConditionType<ReturnTypeState, Condition.ReturnType> => ({
  name: "Return type",
  description(state) {
    if (state.returnTypes.length === 0) return "No return types selected";
    const types = state.returnTypes
      .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
      .join(", ");
    return `Return type is ${types}`;
  },
  Details(props: ConditionTypeDetailsProps<ReturnTypeState>) {
    return React.createElement(Details, props);
  },
  empty: { returnTypes: [] },
  fromModel(model) {
    return returnTypeConditionFromModel(model);
  },
  toModel(state) {
    return { type: Condition.RETURN_TYPE, returnTypes: state.returnTypes };
  },
  valid(state) {
    return validateReturnTypeCondition(state).valid;
  },
});

export { type ReturnTypeState } from "@redotech/redo-model/return-flow/condition-validate";
